export default class {
    constructor() {
        this.defaultCountryCode = 0;
        this.defaultRegionCode = 0;
        this.subTotal = 0;
        this.shippingTotal = 0;
        this.subscriptionTotal = 0;
        this.giftCount = 0;
        this.countryOptionList = [];
        this.regionOptionList = [];
        this.subscriptionForm = $('.js-subscription-form');
        this.$countries = $('.js-country-dropdown');
        this.$regions = $('.js-region-dropdown');
        this.$otherRegion = $('.js-region-name-container');
        this.$promoCodeLabel = $('.js-promo-code-label');
        this.$promoCode = $('.js-promo-code');
        this.currentPromoCode = this.$promoCode.val();
        this.$hiddenInputs = $('.js-hidden-input');
        this.$offerList = $('.js-offer-list');
        this.$formJs = $('.js-form-javascript');
        this.$giftOptions = $('.js-gift-options');
        this.$selfSubscribe = $('.js-self-subscribe');
        this.$giftSubscribe = $('.js-gift-subscribe');
        this.$addGift = $('.js-add-gift');
        this.$giftHeading = $('.js-gift-heading');
        this.$selfShippingForm = $('.js-self-shipping-form');
        this.$giftShippingForm = $('.js-gift-shipping-form');
        this.$addedGiftShippingForm = $('.js-additional-gifts');
        this.$billingIsDifferent = $('.js-billing-is-different');
        this.$billingForm = $('.js-billing-form');
        this.$paymentForm = $('.js-payment-form');
        this.$securityCodeHelpIcon = $('.js-security-code-help-icon');
        this.$securityCodeHelpClose = $('.js-security-code-close');
        this.$securityCodeHelp = $('.js-security-code-help');
        this.$subscriptionPrice = $('.js-subscription-price');
        this.$shippingPrice = $('.js-shipping-price');
        this.$totalPrice = $('.js-total-price');
        this.$formSubmit = $('.js-form-submit');

        // Hidden input fields
        this.bindHiddenFields();
        this.assignClassGlobals();
        this.initialized = false;
    };

    bindHiddenFields() {
        this.$selectedOffer = $('#Offer_no');
        this.$ceoList = $('#CEOList');
        this.$subTotal = $('#SubTotal');
        this.$shippingTotal = $('#Shipping');
        this.$subscriptionTotal = $('#SubscriptionTotal');
        this.$webOrderSetup = $('#WebOrderSetup_No');
        this.$shipper = $('#Shipper_no');
        this.$shippingMethod = $('#ShippingMethod_no');
        this.$giftFlag = $('#GiftFlag');
        this.$buyerCurrency = $('#Buyer_Currency');
    }

    assignClassGlobals() {
        // These javascript variables that appear to have no reference are imported onto
        // the page either on page load or via ajax when a promo code is supplied.
        // All of them come from the publish2profit web form
        this.countries = CountryArray || [];
        this.defaultCountry = PublisherDefaultCountry;
        this.regions = CountryRegionArray || [];
        this.defaultRegion = PublisherDefaultRegion;
        this.allowOther = CountryAllowOtherRegionArray || [];
        this.giftUsage = GiftUsage || 0;
    }

    init() {
        let that = this;

        if (!this.initialized) {
            // Init to USA
            for (let country in this.countries) {
                if (this.countries[country] === this.defaultCountry) {
                    this.defaultCountryCode = country;
                }
                this.countryOptionList.push($.parseHTML('<option value="' + country + '">' + this.countries[country] + '</option>')[0]);
            }
            // Sort Country List alphabetically
            this.sortOptions(this.countryOptionList);

            for (let countryCode in this.regions) {
                for (let region in this.regions[countryCode]) {
                    if (this.defaultRegion && this.regions[countryCode][region] === this.defaultRegion) {
                        this.defaultRegionCode = region;
                    }
                    if (!this.regionOptionList[countryCode]) {
                        this.regionOptionList[countryCode] = [];
                    }
                    this.regionOptionList[countryCode].push($.parseHTML('<option value="' + region + '">' + this.regions[countryCode][region] + '</option>')[0]);
                }
                // Sort Region Lists alphabetically
                this.sortOptions(this.regionOptionList[countryCode]);
            }
            // Populate country list
            this.$countries.each(function() {
                let $this = $(this);
                $this.append($(that.countryOptionList).clone());
                that.bindCountryEvents($this);
            });

            // Set default country
            this.$countries.val(this.defaultCountryCode);

            // Set initial Region list
            this.$regions.each(function() {
                let $this = $(this);
                that.setRegions($this, that.defaultCountryCode);
                that.bindRegionEvents($this);
            });

            // Set default region
            this.$regions.val(this.defaultRegionCode);

            // Update form if promo code is provided or changes
            this.$promoCode.blur(function() {
                // Do nothing if code matches previous code
                if (that.currentPromoCode !== this.value) {
                    that.reloadForm(this.value);
                }
            });

            // Update form if user presses enter in promo code field
            this.$promoCode.keydown(function(e) {
                e = e || window.event;
                let code = e.keyCode ? e.keyCode : e.which;

                if (e.keyCode === 13) {
                    e.preventDefault();
                    if (that.currentPromoCode !== this.value) {
                        that.reloadForm(this.value);
                    }
                }
            });

            this.$selfSubscribe.click(function() {
                that.$selfShippingForm.removeClass('u-hidden');
                that.$giftShippingForm.addClass('u-hidden');
                that.$billingForm.toggleClass('u-hidden', !that.$billingIsDifferent.prop('checked'));
                that.giftCount = 0;
                that.$giftFlag.prop('checked', false);
                that.updatePrice();
            });

            this.$giftSubscribe.click(function() {
                that.$selfShippingForm.addClass('u-hidden');
                that.$giftShippingForm.removeClass('u-hidden');
                that.$billingForm.addClass('u-hidden');
                that.giftCount = 1;
                that.$giftFlag.prop('checked', true);
                that.updatePrice();
            });

            this.$billingIsDifferent.click(function() {
                that.$billingForm.toggleClass('u-hidden', !that.$billingIsDifferent.prop('checked'));
            });

            this.$securityCodeHelpIcon.click(function() {
                that.$securityCodeHelp.toggleClass('u-hidden');
            });

            this.$securityCodeHelpClose.click(function() {
                that.$securityCodeHelp.toggleClass('u-hidden');
            });

            this.bindAddGiftEvents(this.$addGift);

            this.$webOrderSetup.val(WebOrderSetup_No || 0);

            this.subscriptionForm.submit(function() {
                return that.validateForm();
            });

            this.attachOffers();

            this.handleGiftUsage();

            this.initialized = true;
        }
    }

    setRegions($region, countryCode) {
        $region.empty();
        if (countryCode && this.regionOptionList[countryCode]) {
            // Repopulate regions dropdown
            $region.append($(this.regionOptionList[countryCode]).clone());
        }
        // If the country allows for Other regions, add "Other" item
        if (this.allowOther[countryCode] === '1') {
            $region.append('<option value="-99">Other</option>');
        }

        // if Other is chosen, show RegionName field
        this.showRegionName($region.closest('fieldset').find('.js-region-name-container'), $region.val());
    }

    showRegionName($otherRegion, regionCode) {
        if (regionCode === '-99') {
            $otherRegion.removeClass('u-hidden');
        } else {
            $otherRegion.addClass('u-hidden').find('input').val('');
        }
    }

    attachOffers() {
        let that = this,
            multiplier = 1;
        $('input.MultiSourceCode').click(function() {
            let ceoArr = this.title.split(',');
            that.$selectedOffer.val(ceoArr[2]);
            that.$ceoList.val(this.title);
            that.updatePrice();
        });
    }

    bindCountryEvents($countries) {
        let that = this;
        $countries.change(function() {
            that.setRegions($(this).closest('fieldset').find('.js-region-dropdown'), this.value, that.defaultRegionCode);
            that.updatePrice();
        });
    }

    bindRegionEvents($regions) {
        let that = this;
        $regions.change(function() {
            that.showRegionName($(this).closest('fieldset').find('.js-region-name-container'), this.value);
            that.updatePrice();
        });
    }

    bindAddGiftEvents($addGift) {
        let that = this;
        $addGift.click(function() {
            that.giftCount++;
            axios.get('/subscription-shipping-form/' + that.giftCount).then(function(response) {
                if (response.status === 200 && response.data) {
                    // Add new gift form
                    that.$addedGiftShippingForm.append(response.data);

                    // Number gifts in order
                    that.numberGifts();

                    // Populate country list
                    that.$addedGiftShippingForm.find('.js-country-dropdown').each(function() {
                        if ($('option', this).length === 0) {
                            let $this = $(this);
                            $this.append($(that.countryOptionList).clone());
                            // Set default country
                            $this.val(that.defaultCountryCode);
                            that.bindCountryEvents($this);
                        }
                    });

                    // Populate Region list
                    that.$addedGiftShippingForm.find('.js-region-dropdown').each(function() {
                        if ($('option', this).length === 0) {
                            let $this = $(this);
                            that.setRegions($this, that.defaultCountryCode);
                            // Set default region
                            $this.val(that.defaultRegionCode);
                            that.bindRegionEvents($this);
                        }
                    });

                    // Bind event to Add Another Gift
                    that.bindAddGiftEvents(that.$addedGiftShippingForm.find('fieldset').last().find('.js-add-gift'));

                    // Bind event to Remove Gift
                    that.bindRemoveGiftEvents(that.$addedGiftShippingForm.find('fieldset').last().find('.js-remove-gift'));

                    that.updatePrice();
                }
            }).catch(function() {
                alert('There was an issue using that promo code. Please try again.');
            });
        });
    }

    bindRemoveGiftEvents($removeGift) {
        let that = this;
        $removeGift.click(function() {
            $(this).closest('fieldset').remove();
            that.numberGifts();
            that.updatePrice();
        });
    }

    numberGifts() {
        let giftLabels = $('.js-gift-label');
        giftLabels.each(function(i) {
            let label = `Gift #${i + 1} of ${giftLabels.length}`;
            if (giftLabels.length <= 1) {
                label = '';
            }
            this.innerHTML = label;
        });
    }

    handleGiftUsage() {
        // Toggle "For Myself" based on gift type
        this.$selfSubscribe.toggleClass('u-hidden', !!this.giftUsage);
        this.$giftOptions.toggleClass('u-hidden', !!this.giftUsage);
        this.$giftHeading.toggleClass('u-hidden', this.giftUsage === 1);
        // giftUsage meaning: 0 = Normal Usage, 1 = Disable Gifts, 2 = Force Gifts
        if (this.giftUsage === 2) {
            this.$giftSubscribe.click();
        } else if (this.giftUsage === 1) {
            this.$selfSubscribe.click();
        }

        let hidePromoCodeLabel = true;
        if (this.currentPromoCode !== '' || this.giftUsage === 1) {
            hidePromoCodeLabel = false;
        }
        this.$promoCodeLabel.toggleClass('u-hidden', hidePromoCodeLabel);
    }

    reloadForm(code) {
        let that = this;
        axios.get('/subscribe/' + code).then(function(response) {
            if (response.status === 200 && response.data) {
                // Update Hidden input fields
                that.$hiddenInputs.html(response.data.hiddenInputs);
                that.bindHiddenFields();

                // Update Javascript
                that.$formJs.html(response.data.javascript);
                $.globalEval(response.data.javascript);
                that.$webOrderSetup.val(WebOrderSetup_No || 0);
                that.assignClassGlobals();

                // Promo Code
                that.$promoCode.val(response.data.code);
                that.currentPromoCode = response.data.code;

                // Update Offers - detach and reattach events
                $('input.MultiSourceCode').off('click');
                that.$offerList.html(response.data.offers.join('\n'));
                that.attachOffers();

                that.giftUsage = GiftUsage;
                that.handleGiftUsage();
                that.updatePrice();
            }
        }).catch(function() {
            alert('There was an issue using that promo code. Please try again.');
        });
    }

    updatePrice() {
        if (this.$ceoList.val() === '') {
            // No offer chosen, skip
            this.$paymentForm.addClass('u-hidden');
            this.$formSubmit.addClass('u-disabled').prop('disabled', true);
            return;
        }

        let that = this,
            params = {
                ceoList: this.$ceoList.val(),
                country_no: this.$countries.val(),
                region_no: this.$regions.val(),
                billing_region_no: $('[name=Billing_Billing_Region_no]').val(),
                shipper_no: this.$shipper.val(),
                shippingMethod_no: this.$shippingMethod.val(),
            },
            subscriptionCount = 1;

        if (this.$giftFlag.prop('checked')) {
            subscriptionCount = 0;
            params['giftFlag'] = this.$giftFlag.prop('checked');
            params['giftCountries'] = {};
            params['giftRegions'] = {};
            $('.js-gift-shipping-form [name*=Shipping_Country_no]').map(function() {
                params['giftCountries'][this.name] = this.value;
                subscriptionCount++;
            });
            $('.js-gift-shipping-form [name*=Shipping_Region_no]').map(function() {
                params['giftRegions'][this.name] = this.value;
            });
        }

        axios.post('/subscription-price', params).then(function(response) {
            if (response.status === 200 && response.data) {
                that.subTotal = parseFloat(response.data.RevenueValue);
                that.shippingTotal = parseFloat(response.data.ShippingValue);
                that.subscriptionTotal = that.subTotal + that.shippingTotal;

                // Update subtotal field
                that.$subTotal.val(that.subTotal);

                // Update shipping field
                that.$shippingTotal.val(that.shippingTotal);

                // Update subscriptionTotal field
                that.$subscriptionTotal.val(that.subscriptionTotal);

                // Update Buyer Currency
                that.$buyerCurrency.val(response.data.BuyerCurrency);

                // Update visible total field
                that.$paymentForm.removeClass('u-hidden');
                that.$subscriptionPrice.html(that.subTotal.toFixed(2));
                that.$shippingPrice.html(that.shippingTotal.toFixed(2));
                that.$totalPrice.html(that.subscriptionTotal.toFixed(2));

                that.$formSubmit.removeClass('u-disabled').prop('disabled', false);
            }
        }).catch(function(e) {
            alert('There was an issue getting the subscription pricing. Please try again.');
        });
    }

    validateForm() {
        let errors = false,
            firstError = null;

        // Validate an offer is selected
        if ($('input.MultiSourceCode:checked').length === 0) {
            // The form can't be in this state, hard error
            $('input.MultiSourceCode').closest('.js-offer-list:not(.is-error)').addClass('is-error').prepend(`<p class='small help'>You must select an offer to continue</p>`);
            $('input.MultiSourceCode').click(function() {
                $(this).closest('.is-error').removeClass('is-error').find('p.help').remove();
                $('input.MultiSourceCode').off('click');
            });
            return false;
        }

        // Reset hidden error fields
        $('.is-error :input:not(:visible)').off('change').closest('.is-error').removeClass('is-error').find('p.help').remove();

        $('.js-self-shipping-form, .js-gift-shipping-form, .js-billing-form, .js-payment-form').find(':input').filter('[required]:visible').each(function() {
            // credit cards can vary in length from 14 to 22 numbers (including spaces)
            if ($(this).val() === '' || (this.name === 'CCNumber' && this.value.match(/^[\d -]{14,22}$/) === null)) {
                $(this).closest('.control:not(.is-error)').addClass('is-error').append(`<p class='small help'>${this.placeholder} cannot be empty</p>`);
                errors = true;

                if (firstError === null) {
                    firstError = this;
                }
            }
        });

        // bring focus to first error field
        if (firstError) {
            firstError.focus();
        }

        let removeValidation = function() {
            if ($(this).val() !== '' && (this.name !== 'CCNumber' || this.value.match(/^[\d -]{14,22}$/) !== null)) {
                $(this).closest('.is-error').removeClass('is-error').find('p.help').remove();
                $(this).off('change');
            }
        };

        // Bind each error field to remove its flags if fixed, remove event afterwards
        $('.is-error input, .is-error select').blur(removeValidation);
        $('.is-error input, .is-error select').change(removeValidation);

        if (!errors) {
            return true;
        }

        return false;
    }

    sortOptions(optionArr) {
        optionArr.sort(function(a, b) {
            let textA = a.text.toLowerCase(),
                textB = b.text.toLowerCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    }
}